import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { CompanyLocations } from "@/pages";
import React from "react";
import { permissionsEnergy } from "@/utils";
import { locationMeterRoutes } from "./locationMeterRoutes";

type argsType = {
  showLocations?: boolean;
  showAddLocation?: boolean;
  showEditLocation?: boolean;
  showDeleteLocation?: boolean;
};

export const locationRoutes = (
  parentPath: string,
  args: argsType = {},
): React.ReactElement[] => [
  <Route
    key="locations"
    path=""
    element={
      <ProtectedRoute
        element={
          <CompanyLocations
            showAdd={args?.showAddLocation}
            showEdit={args?.showEditLocation}
            showDelete={args?.showDeleteLocation}
          />
        }
        codes={permissionsEnergy}
      />
    }
  />,
  <Route path="meters/:energyType">{locationMeterRoutes(parentPath)}</Route>,
];
